import { notifications } from "@mantine/notifications";

export const showSuccess = (message: string, title?: string): void => {
  notifications.show({
    title,
    message,
    color: "green",
  });
};

export const showError = (message: string, title?: string): void => {
  notifications.show({
    title,
    message,
    color: "red",
  });
};

export const showInfo = (message: string, title?: string): void => {
  notifications.show({
    title,
    message,
    color: "blue",
  });
};

export const showLoading = (id: string, message: string, title?: string): void => {
  notifications.show({
    id,
    title,
    message,
    color: "yellow",
    loading: true,
    autoClose: false,
  });
};

export const updateNotification = (
  id: string,
  message: string,
  color: "green" | "red" | "yellow" | "blue" | "orange",
  title?: string,
): void => {
  notifications.update({
    id,
    title,
    message,
    color,
    loading: false,
  });
};

export const hideNotification = (id: string): void => {
  notifications.hide(id);
};
